// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609180504/js/" + chunkId + "." + {"44":"3f2bb2fa","225":"a378897d","481":"0600863f","486":"9019bd4a","770":"5712b0ba"}[chunkId] + ".0.7280490038897593.chunk.js";
};